import { advisorApi as api } from './advisor.api';

export const advisorActions = {
  async getAdvisors({ commit }, payload) {
    try {
      commit('GET_ADVISORS_LOADING');
      const response = await api.getAdvisors(payload);
      commit('GET_ADVISORS_SUCCESS', response.data);
      return response;
    } catch (error) {
      commit('GET_ADVISORS_ERROR', error.response);
    }
  },
  async getAdvisor({ commit }, id) {
    try {
      commit('GET_ADVISOR_LOADING');
      const response = await api.getAdvisor(id);
      commit('GET_ADVISOR_SUCCESS', response.data);
    } catch (error) {
      commit('GET_ADVISOR_ERROR', error.response);
    }
  },
  async addAdvisor({ commit }, body) {
    try {
      commit('ADD_ADVISOR_LOADING');
      const response = await api.addAdvisor(body);
      commit('ADD_ADVISOR_SUCCESS', response.data);
    } catch (error) {
      commit('ADD_ADVISOR_ERROR', error.response);
    }
  },
  async deleteAdvisor({ commit }, id) {
    try {
      commit('DELETE_ADVISOR_LOADING');
      const response = await api.deleteAdvisor(id);
      commit('DELETE_ADVISOR_SUCCESS', response.data);
    } catch (error) {
      commit('DELETE_ADVISOR_ERROR', error.response);
    }
  },
  async updateAdvisor({ commit }, { id, body }) {
    try {
      commit('UPDATE_ADVISOR_LOADING');
      const response = await api.updateAdvisor(id, body);
      commit('UPDATE_ADVISOR_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_ADVISOR_ERROR', error.response);
    }
  },
  async getAdvisorAppointmentConfig({ commit }, id) {
    try {
      commit('GET_ADVISOR_APPOINTMENT_CONFIG_LOADING');
      const response = await api.getAdvisorAppointmentConfig(id);
      commit('GET_ADVISOR_APPOINTMENT_CONFIG_SUCCESS', response.data);
    } catch (error) {
      commit('GET_ADVISOR_APPOINTMENT_CONFIG_ERROR', error.response);
    }
  },
  async updateAdvisorAppointmentConfig({ commit }, { id, body }) {
    try {
      commit('UPDATE_ADVISOR_APPOINTMENT_CONFIG_LOADING');
      const response = await api.updateAdvisorAppointmentConfig(id, body);
      commit('UPDATE_ADVISOR_APPOINTMENT_CONFIG_SUCCESS', response.data);
    } catch (error) {
      commit('UPDATE_ADVISOR_APPOINTMENT_CONFIG_ERROR', error.response);
    }
  },
};
